// Conditional Sentry init. We don't pin @sentry/react in deps yet — the
// integration is opt-in. To activate in a deployment:
//   1. pnpm add @sentry/react
//   2. set VITE_SENTRY_DSN in the environment
//   3. add the Sentry init below (uncomment the import + Sentry.init call)
//
// Once @sentry/react is added, replace this stub with a real init:
//
//   import * as Sentry from '@sentry/react';
//   Sentry.init({
//     dsn: env.sentryDsn,
//     environment: env.environment,
//     tracesSampleRate: env.isProduction ? 0.1 : 0,
//   });
//
// The component itself is render-once (returns null) and lives at the
// top of AppProviders so it boots before any feature code.
import { useEffect } from 'react';
import { env } from '@config/env';

export default function SentryBootstrap() {
  useEffect(() => {
    if (!env.sentryDsn) return;
    if (import.meta.env.DEV) {
      console.info('[sentry] DSN present but @sentry/react is not installed — skipping init.');
    }
    // Placeholder for the future real init — see header comment.
  }, []);
  return null;
}
